// extracted by mini-css-extract-plugin
module.exports = {"borders":"NestedComponent_borders__1GjW0","background":"NestedComponent_background__JBDPc"};